import React from "react";
import ReactECharts from "echarts-for-react";
import DropdownMenu from "../../pages/ui/DropdownMenu";

interface ChartSeries {
  name: string;
  data: number[];
  color: string;
}

interface LineChartProps {
  title?: string;
  xAxisData: string[];
  series: ChartSeries[];
  height?: number;
  showLegend?: boolean;
  smooth?: boolean;
  filterOptions?: string[];
  onFilterChange?: (value: string) => void;
  currentFilter?: string;
}

const LineChart: React.FC<LineChartProps> = ({
  title = "",
  xAxisData,
  series,
  height = 300,
  showLegend = true,
  smooth = true,
  filterOptions = [
    { label: "Today", value: "today", onClick: () => {} },
    { label: "Weekly", value: "weekly", onClick: () => {} },
    { label: "Monthly", value: "monthly", onClick: () => {} },
  ],
  onFilterChange,
  currentFilter = "Monthly",
}) => {
  const options = {
    tooltip: { trigger: "axis" },
    legend: showLegend
      ? {
          data: series.map((s) => s.name),
          bottom: 0,
        }
      : undefined,
    grid: {
      left: "3%",
      right: "4%",
      bottom: showLegend ? "15%" : "3%",
      top: "5%", // reduced since we removed chart title
      containLabel: true,
    },
    xAxis: {
      type: "category",
      data: xAxisData,
      boundaryGap: false,
      axisLine: { lineStyle: { color: "#e5e7eb" } },
      axisLabel: { color: "#2A2A2A", fontSize: 12 },
    },
    yAxis: {
      type: "value",
      axisLine: { show: false },
      axisTick: { show: false },
      splitLine: { lineStyle: { color: "#f3f4f6" } },
      axisLabel: {
        color: "#2A2A2A",
        fontSize: 12,
        formatter: (value: number) => `N${(value / 1000).toFixed(0)}K`,
      },
    },
    series: series.map((s) => ({
      name: s.name,
      type: "line",
      data: s.data,
      lineStyle: { color: s.color, width: 2 },
      itemStyle: { color: s.color },
      smooth: smooth,
      symbol: "circle",
      symbolSize: 6,
    })),
  };

  return (
    <div className="bg-white p-6 rounded-lg w-full">
      {/* Header */}
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-base font-semibold text-gray-700">{title}</h3>

        {/* Filter */}
        <DropdownMenu
          options={filterOptions}
          icon={<img src="/assets/images/svg/filter.svg" alt="filter" />}
          label={"Filter"}
        />
      </div>

      {/* Chart */}
      <ReactECharts option={options} style={{ height, width: "100%" }} />
    </div>
  );
};

export default LineChart;
